import InputField from "../../InputField/InputField";
import { HeadingTitle } from "../ModalContainer";
import vectorUploadIcon from "../../../Assets/Icons/Vector.png";
import { toast } from "react-toastify";
import { useDropzone } from "react-dropzone";
import { useCallback, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useSpring, animated } from "react-spring";
import axios from "axios";
import Loader from "../../Loading/Loading";
import { BASEURI } from "../../../Middleware/axiosInstance";

const CADMarker = ({ title, close, cut_id }) => {
  // const BASE_URL = localStorage.getItem("baseurl");
  const baseDomain = BASEURI.split("/")[0] + "//" + BASEURI.split("/")[2];

  const [weight, setWeight] = useState("");
  const [files, setFiles] = useState();
  const [filePreviews, setFilePreviews] = useState(false);
  const [showPreview, setshowPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  // Dropzone code ends here

  const onDrop = useCallback((acceptedFiles) => {
    const selectedFile = acceptedFiles[0];

    if (!selectedFile) {
      toast.error("No file selected.");
      return;
    }

    if (selectedFile.type !== "application/pdf") {
      toast.error("Invalid file format. Only PDF files are allowed.");
      return;
    }

    setFiles(selectedFile);
    setFilePreviews(URL.createObjectURL(selectedFile));
    setshowPreview(true);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const previewInAnimation = useSpring({
    opacity: showPreview ? 1 : 0,
    transform: showPreview ? "scale(1)" : "scale(0)",
    config: { duration: 10 },
  });

  const handleChange = (value) => {
    setWeight(value);
  };

  const handleSubmit = async () => {
    try {
      if (!weight) {
        toast.error("Please enter the estimated weight.");
        return;
      }
      setLoading(true);
      const formData = new FormData();
      formData.append("cad", files);
      formData.append("estimation_weight", weight);

      const { data } = await axios.post(
        `${baseDomain}/ManufactureOrders/ajaxUploadCadMarker/${cut_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (data.status === 1) {
        toast.success("Submitted Successfully");
      } else {
        toast.error(data?.msg);
      }
      setLoading(false);
      close();
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <div>
      <HeadingTitle title={title} center={false} closeModal={close} />
      <div className="mtx1-3">
        <div>
          <InputField
            label={"Estimated Weight"}
            placeholder={"Enter weight"}
            onChange={handleChange}
            name={"weight"}
          />
        </div>
      </div>
      <div className="mt-3 text-center">
        <div className="browse-files" {...getRootProps()}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <>
              <img src={vectorUploadIcon} alt="" />
              <h2 className="upload-tag">Upload CAD</h2>
              <p className="drag-tag">
                Drag and Drop file here Or <span>Choose file</span>
              </p>
              <p className="drag-small-tag">
                Support formats: PDF | Minimum size: 5 MB
              </p>
            </>
          ) : (
            <>
              <img src={vectorUploadIcon} alt="" />
              <h2 className="upload-tag">Upload CAD</h2>
              <p className="drag-tag">
                Drag and Drop file here Or <span>Choose file</span>
              </p>
              <p className="drag-small-tag">
                Support formats: PDF | Minimum size: 5 MB
              </p>
            </>
          )}
        </div>
      </div>
      {files && (
        <animated.div style={previewInAnimation} className="file-previews">
          <span
            onClick={() => {
              setshowPreview(false);
              setFilePreviews(null);
              setFiles(null);
            }}
          >
            <RxCross2 />
          </span>
          <iframe title={files?.name} src={filePreviews} alt="pdf" />
        </animated.div>
      )}
      <div className="mt-3 text-center">
        <button
          className="add-btn"
          disabled={weight === null || weight === "" || weight === undefined}
          onClick={handleSubmit}
          style={{ backgroundColor: "#3C94C6" }}
        >
          {loading ? <Loader color={"#ffffff"} size={18} /> : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default CADMarker;
